
import springboard from 'springboard';

import '@/modules/mantine/mantine_module';

import {ApplicationShell} from './application_shell';

springboard.registerModule('ApplicationShell', {}, async (moduleAPI) => {
    moduleAPI.registerApplicationShell(ApplicationShell);
});

